import Form from './Form';

export const SignInForm = () => {
  const handleDownload = () => {};

  return (
    <div className="w-100 h-100 row p-0 m-0">
      <div className="w-100 h-xs-50 h-md-100 col-xs-12 col-md-6 p-0 m-0">
        <img src="/election.png" alt="election" className="w-100 h-100" />
      </div>

      <div className="w-100 col-xs-12 col-md-6 p-0 m-0 bg-white d-flex align-items-center justify-content-center p-20">
        <div className="d-flex justify-content-center flex-column gap-9 align-items-center">
          <Form handleDownload={handleDownload} />
        </div>
      </div>
    </div>
  );
};
